// extracted by mini-css-extract-plugin
module.exports = {"page":"ErrorView_page__cr68S","hero":"ErrorView_hero__x9aCZ","contentGap":"ErrorView_contentGap__lYmTx"};